import { ContractCostTypeEnum } from "@enums/contractCostType.enum";
import { ContractIntervalEnum } from "@enums/contractInterval.enum";
import { ContractPaymentTypeEnum } from "@enums/contractPaymentType.enum";
import { Model } from "@interfaces/model.interface";

export interface Contract extends Model {
	autoRenew: boolean;
	contractValue: number;
	coolingPeriodDays: number;
	costType: ContractCostTypeEnum;
	documents: string;
	endDate: Date;
	intervalType: ContractIntervalEnum;
	intervalValue: number;
	maximumSpend: number;
	minimumSpend: number;
	name: string;
	paymentTermId: number;
	paymentType: ContractPaymentTypeEnum;
	siteId: number;
	startDate: Date;
	supplierContactId: number;
	supplierId: number;
	terminationDays: number;
	totalIntervals: number;
}

export class Contract implements Contract {
	siteId = 1;
	
	constructor(data?: Partial<Contract>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}